import { styled } from '../../../stitches.config';

export const Table = styled('table', {
  borderSpacing: 0,
  width: '100%',
  minWidth: '$tablet',
  '@laptopAndUp': {
    tableLayout: 'fixed',
  },
});

export const TableCell = styled('td', {
  padding: '$spacing-2x $spacing-1x',
});

export const TableHeadCell = styled('th', {
  borderBottom: '1px solid $skin-grey',
  color: '$skin-grey',
  fontWeight: '$regular',
  paddingLeft: '$spacing-1x',
  paddingRight: '$spacing-1x',
  paddingTop: '$spacing-1x',
  textAlign: 'left',
});

export const TableRow = styled('tr', {
  '&:nth-child(2n)': {
    backgroundColor: '$skin-accent1-lighten3',
  },
  '&:nth-last-child(n + 2) td': {
    borderBottom: 'none',
  },
});
